import { v4 as uuidv4 } from 'uuid'

export const LD_EXTENSION_ID = 'ikmdkpfjmcjbfcpggiagkclbdhkfdcfp'
export const SENDER = uuidv4()
